import { render } from "./ObjectsSettings.vue?vue&type=template&id=95807efe"
import script from "./ObjectsSettings.vue?vue&type=script&lang=js"
export * from "./ObjectsSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__